import { useMentorshipsByStudent } from "@/entities/mentorship";
import { useSessionStore } from "@/entities/session";
import { ContactsOutdatedButton } from "@/features/ContactsOutdatedButton";
import { SelectMentorButton } from "@/features/SelectMentorButton/SelectMentorButton";
import { Button } from "@/shared/ui/button";
import { Input } from "@/shared/ui/input";
import { Label } from "@/shared/ui/label";
import { Modal } from "@/shared/ui/Modal";

interface MentorInfoProps {
  className?: string;
  textSm?: boolean;
}

export const MentorInfo = ({ className, textSm = true }: MentorInfoProps) => {
  const { user } = useSessionStore();
  const _id = user?._id!;

  const { data } = useMentorshipsByStudent({
    pageSize: 1,
    currentPage: 1,
    studentId: _id,
    status: "active",
  });

  if (data?.total === 0) {
    return <SelectMentorButton />;
  }

  return (
    <Modal>
      <Modal.Trigger className={className} asChild>
        <div>
          <Label
            className={`text-sm ${textSm ? "font-normal md:text-[12px]" : "text-[16px] font-semibold text-textColor"}`}
          >
            Связь с наставником
          </Label>
          <Button variant="outline" className="w-full text-textColor">
            Наставник
          </Button>
        </div>
      </Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Информация о наставнике</Modal.Title>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label className="text-textColor">Телеграм для связи</label>
            <Input readOnly value={data?.data[0].mentor.contacts?.main} />
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-textColor">Резервный телеграм</label>
            <Input readOnly value={data?.data[0].mentor.contacts?.reserve} />
          </div>
        </div>
        <div className="flex flex-col items-center gap-2">
          <ContactsOutdatedButton />

          <Modal.Close />
        </div>
      </Modal.Content>
    </Modal>
  );
};
